/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var waitForEl = function (selector, callback, index) {
  var timeout = 100 * (index < 10 ? index + 1 : 10);
  if (jQuery(selector).length) {
    callback();
  }
  // setTimeout(function () {
  //   waitForEl(selector, callback, index + 1);
  // }, timeout);
};
document.addEventListener("DOMContentLoaded", function() {

  // Klevu customise search result and search bar
  let width = $('.search-bar').width();
      html = `<p class="search-title">Search Results</p>`,
      filter_icon = `<svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.07031 0.789062C1.23438 0.460938 1.5625 0.25 1.9375 0.25H12.0625C12.4141 0.25 12.7422 0.460938 12.9062 0.789062C13.0469 1.11719 13 1.51562 12.7656 1.79688L8.5 7.02344V10C8.5 10.3047 8.33594 10.5625 8.07812 10.6797C7.82031 10.7969 7.51562 10.7734 7.28125 10.6094L5.78125 9.48438C5.59375 9.34375 5.5 9.13281 5.5 8.875V7.02344L1.21094 1.79688C0.976562 1.51562 0.929688 1.11719 1.07031 0.789062Z" fill="white"/></svg>`,
      collection_header = $('.collection-header').clone();
    
    $('#klevu-quick-search-theme-styles').remove();

    $('.search-bar__input').on('focus', ()=> {
      $('.klevuTarget.klevu-fluid>.klevuWrap').addClass('update-css').width(width);
    })

    $('.search-bar__input').on('input', ()=> {
      setTimeout(() => {
        $('.klevuTarget.klevu-fluid>.klevuWrap').addClass('update-css').width(width);
      }, 1500);
    })
    klevu.event.attach(
    document.querySelector(".klevuLanding"),
    "click",
    function(el){
      const search = window.location.href.split('?q=')[1];

      //  ** shopping list
      // 
      if(!el.isTrusted ) {
        const results = $('.kuResultsHeadingTitleContainer').clone(),
              results_count = $('.kuTab.kuTabSelected b').text(),
              result_text = results_count + ` results found for '${search}'`,
              collection_results_count = $('.kuResultsNumber').text(),
              collection_text = `Showing ${collection_results_count} products`,
              page = $('.search-results-page').length > 0 ? 'search' : $('.collection-page').length > 0 ? 'collection' : '';

        // $('[data-block-id="ku_landing_result_header"]').append(left_elm);
        if(page === 'search') {
          $('header[data-block-id="ku_landing_result_header"]').before(html);
          // $('header[data-block-id="ku_landing_result_header"]').prepend(result_text);
          $('[data-block-id="ku_landing_left_facets"]').before(html);
          $('[data-block-id="ku_landing_left_facets"]').before(results);
        } else if( page === 'collection') {
          $('header[data-block-id="ku_landing_result_header"]').before(collection_header.removeClass('mobile-only').addClass('desktop-only'));
          $('.collection__results').html(collection_text);
          $('section[data-container-id="ku_landing_main_content_center"] .collection-header').removeClass('hidden');
        }


        // Both search & collection page
        $('.kuResults .klevuProduct').each((index, product) => {
          const product_handle = $(product).find('.kuName a').attr('href').split('/').pop(); 
          let product_id = '',
              product_title = '',
              product_tags = [],
              in_store = false,
              restricted = false,
              pharmacist_only = true,
              restrict_pharmacist_product = false,
              product_url = '',
              additional_info = $('.collection-page').data('additional-info');

          fetch('/products/' + product_handle + '.js').then(response => {
            return response.json();
          })
          .then((response) => {
            // pharmacist_only
            if (product.type === '_pharmacist-only') pharmacist_only = true;
            product_tags.forEach(tag => {
              if(tag === '__label1:Pharmacist Only') pharmacist_only = true;
              if(tag === '__label1:Instore Only'){in_store = true;}
            })
            //console.log('response!!!', response);
            response.tags.forEach(prodTag => {
              //console.log('tag', prodTag);
              if(prodTag === 'restricted') restricted = true;
            })

            response.tags.forEach(prodTag => {
              if(prodTag === 'PRODTYPE=Pharmacist Only') restrict_pharmacist_product = true;
            })
            
            const variantId = $(product).data('id'),
                  productId = response.id,
                  binData = $(product).data('bin'),
                  binLocation = response.bin_location,
                  productTitle = response.title,

                  restrictedCode = `<div class="shopping_list customjs">
                                <button href="#" class="check-instore-toggle"> <img src="https://cdn.shopify.com/s/files/1/0317/1926/0297/files/clickicon-new.png" width="25" height="25" alt=""/>
                                 </button>
                                <div class="storelocation-popup" data-prodid="${variantId}">
                                <div class="close-storelocation-popup">&#x2715;</div>
                                <h3>Search for your closest store</h3>

                                <input type="text" class="location-input" placeholder="Search by suburb, postcode...">
                                <button class="find-store">Find store</button>
                                <div class="error"></div>
                                <button class="use-location"><img src="https://cdn.shopify.com/s/files/1/0317/1926/0297/files/gps_1-new.png" width="14" height="14" /></button>

                                <div class="store-output"></div>
                                <div class="location-buttons">
                                  <div class="load-more-stores">Load more stores</div>
                                  <div class="hide-stores">Hide stores</div>
                                </div>
                                </div>
                              </div>`,

                  wishlist = `<div class="shopping_list customjs">
                                <form method="post" action="/cart/add">
                                  <input type="hidden" name="id" value="${variantId}" />
                                  <input type="hidden" id="custom_message" name="properties[_bin_location]" value="${binData}" />
                                  <input min="1" type="number" id="quantity" name="quantity" value="1" class="hidden"/>
                                  <input type="submit" value="Add to cart" class="button button--primary collection-button" data-action="add-to-cart" />
                                </form>
                                <button onClick="addToCartAjax(this,${variantId});" style="display:none" class="button button--primary collection-button custom-add-to-cart pharmacist-${restrict_pharmacist_product}">Add to cart</button>
                                <button href="#" class="check-instore-toggle"> <img src="https://cdn.shopify.com/s/files/1/0317/1926/0297/files/clickicon-new.png" width="25" height="25" alt=""/>
                                 </button>
                                <div class="storelocation-popup" data-prodid="${variantId}">
                                <div class="close-storelocation-popup">&#x2715;</div>
                                <h3>Search for your closest store</h3>

                                <input type="text" class="location-input" placeholder="Search by suburb, postcode...">
                                <button class="find-store">Find store</button>
                                <div class="error"></div>
                                <button class="use-location"><img src="https://cdn.shopify.com/s/files/1/0317/1926/0297/files/gps_1-new.png" width="14" height="14" /></button>

                                <div class="store-output"></div>
                                <div class="location-buttons">
                                  <div class="load-more-stores">Load more stores</div>
                                  <div class="hide-stores">Hide stores</div>
                                </div>
                                </div>
                              </div>`,
                  additionalInfo = `<div class="additional-info test">
                                      <div class="info">
                                        <img src="//cdn.shopify.com/s/files/1/0317/1926/0297/files/noun_clock_20x.png" style="height: 20px;" height="20" />
                                        <p>Fast & Free Delivery on orders over $50</p>
                                      </div>
                                    </div>`;
              // if( pharmacist_only || !in_store ) {
              //   console.log(product.title, ' >>>>>>>>')
              //   const pharmacist_addToCart = `<a href="${product_url}" class="kuBtn kuBtnDark" role="button" tabindex="0">Add to Cart</a>`;
              //   $(product).find('.kuAddtocart').html(pharmacist_addToCart);
              // }
            const pharmacist_addToCart = `<a href="${product_url}" class="kuBtn kuBtnDark" role="button" tabindex="0">Add to Cart</a>`;
            $(product).find('.kuAddtocart').html(pharmacist_addToCart);

            if (restricted) {
              $(product).find('.kuProdAdditional').append(restrictedCode);
            } else {
              $(product).find('.kuProdAdditional').append(wishlist);
            }
            $(product).find('.kuProdAdditional').addClass('wishlist');
            
            if(additional_info || additional_info === 'true') $(product).find('.kuProdAdditional').before(additionalInfo);

        
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        })


        
        
    
        $('.kuSalePrice.kuSpecialPrice').each((index, item) => {
          const without_nz = $(item).text().replace('NZ$ ', '$');
          $(item).text(without_nz);
        })
    
        $('.kuFilters').before(`<div class="button button--primary filter-button">${filter_icon} Filter By</button>`)
        $('.kuFiltersTitleHeading').text('Filter By').css('opacity', '1');
        $('.search-loading').addClass('close');
    
        $('body').on('click', '.filter-button', (el) => {
          if(!$(el.currentTarget).next().hasClass('open')) {
            $(el.currentTarget).next().addClass('open');
            $(el.currentTarget).replaceWith(`<div class="button button--primary filter-button">${filter_icon} Close Filters</div>`);
          } else {
            $(el.currentTarget).next().removeClass('open');
            $(el.currentTarget).replaceWith(`<div class="button button--primary filter-button">${filter_icon} Filter By</div>`);
          }
        });
        $('.klevuTarget.klevu-fluid>.klevuWrap').addClass('update-css').width(width);
      }

      
    }
  );  
});

$(document).ready(function () {
  // upsize sorting by value 
  if ($('.product-options').length) {
    var reA = /[^a-zA-Z]/g;
    var reN = /[^0-9]/g;

    function sortAlphaNum(a, b) {
      var a = a.value;
      var b = b.value;

      var aA = a.replace(reA, "");
      var bA = b.replace(reA, "");
      if (aA === bA) {
        var aN = parseInt(a.replace(reN, ""), 10);
        var bN = parseInt(b.replace(reN, ""), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
      } else {
        return aA > bA ? 1 : -1;
      }
    }

    let data = JSON.parse($('.product-options').html()),
      html = '',
      id = $('.product-options').data('product-id'),
      icon = $('.icon-checked').html(),
      text = $('.product-options').data('upsize-text');
    var badge = false;
    data.sort(sortAlphaNum);

    data.forEach(item => {
      html += `<a href="/products/${item.handle}" class="product-option-link ${item.pid === id ? 'active' : ''}">
                ${item.value}
                <span class="${!badge ? 'hidden' : ''}">${text ? text : 'Upsize'}</span>
                <span class="checked-icon">${icon}</span>
              </a>`
      if (item.pid === id) badge = true;
    })
    $('.product-options').html(html).removeClass('hidden');
  }

  if ($('.locations-page').length) {
    $northButton = $('#north_button');
    $northContainer = $('.north-island');

    $southButton = $('#south_button');
    $southContainer = $('.south-island');

    $('.location-block:not(.coming-soon)').each(function () {
      var locationJSON = JSON.parse($(this).find('.location-json').text());
      $(this)
        .find('.details')
        .click(function () {
          //clearLocationPage();
          //buildLocationPage(locationJSON);
          //renderLocationPage();
        });
    });

    $(this)
      .find('.close-selected')
      .click(function () {
        closeLocationPage();
      });

    function clearLocationPage() {
      $selectedLocation = $('.selected-location');
      $selectedLocation.find('.selected-location--name').text('');
      $selectedLocation.find('.selected__address_1').text('');
      $selectedLocation.find('.selected__address_2').text('');
      $selectedLocation.find('.selected__email').text('');
      $selectedLocation.find('.selected__email').attr('href', '');
      $selectedLocation.find('.selected__directions').attr('href', '');
      $selectedLocation.find('.selected__phone').text('ph: ');
      $selectedLocation.find('.selected__fax').text('fax: ');
      //Hours
      $selectedLocation.find('.selected__monday').text('');
      $selectedLocation.find('.selected__tuesday').text('');
      $selectedLocation.find('.selected__wednesday').text('');
      $selectedLocation.find('.selected__thursday').text('');
      $selectedLocation.find('.selected__friday').text('');
      $selectedLocation.find('.selected__saturday').text('');
      $selectedLocation.find('.selected__sunday').text('');
      $selectedLocation.find('.selected__holidays').text('');
      //Services
      $selectedLocation
        .find('.selected__service_1 .selected-location--service-name')
        .text('');
      $selectedLocation
        .find('.selected__service_1 .selected-location--service-price')
        .text('');
      $selectedLocation
        .find('.selected__service_2 .selected-location--service-name')
        .text('');
      $selectedLocation
        .find('.selected__service_2 .selected-location--service-price')
        .text('');
      $selectedLocation
        .find('.selected__service_3 .selected-location--service-name')
        .text('');
      $selectedLocation
        .find('.selected__service_3 .selected-location--service-price')
        .text('');
      $selectedLocation
        .find('.selected__service_4 .selected-location--service-name')
        .text('');
      $selectedLocation
        .find('.selected__service_4 .selected-location--service-price')
        .text('');
      $selectedLocation
        .find('.selected__service_5 .selected-location--service-name')
        .text('');
      $selectedLocation
        .find('.selected__service_5 .selected-location--service-price')
        .text('');
      //Map
      $selectedLocation.find('.selected__map_embed').html('');
      $selectedLocation.find('.selected__full_map').attr('href', '');
    }

    function buildLocationPage(JSON) {
      $selectedLocation = $('.selected-location');
      $selectedLocation
        .find('.selected-location--name')
        .text('Bargain Chemist ' + JSON.name);
      $selectedLocation.find('.selected__address_1').text(JSON.store_address_1);
      $selectedLocation.find('.selected__address_2').text(JSON.store_address_2);
      $selectedLocation.find('.selected__email').text(JSON.email);
      $selectedLocation
        .find('.selected__email')
        .attr('href', 'mailto:' + JSON.email);
      $selectedLocation
        .find('.selected__directions')
        .attr('href', htmlDecode(JSON.directions_link));
      $selectedLocation.find('.selected__phone').text('ph: ' + JSON.phone);
      $selectedLocation.find('.selected__fax').text('fax: ' + JSON.fax);
      $selectedLocation.find('.selected__call').attr('href', JSON.call);
      //Hours
      $selectedLocation.find('.selected__monday').text(JSON.hours.monday);
      $selectedLocation.find('.selected__tuesday').text(JSON.hours.tuesday);
      $selectedLocation.find('.selected__wednesday').text(JSON.hours.wednesday);
      $selectedLocation.find('.selected__thursday').text(JSON.hours.thursday);
      $selectedLocation.find('.selected__friday').text(JSON.hours.friday);
      $selectedLocation.find('.selected__saturday').text(JSON.hours.saturday);
      $selectedLocation.find('.selected__sunday').text(JSON.hours.sunday);
      $selectedLocation
        .find('.selected__holidays')
        .text(JSON.hours.public_holiday);
      //Services
      $selectedLocation
        .find('.selected__service_1 .selected-location--service-name')
        .text(JSON.services.service_1.title);
      $selectedLocation
        .find('.selected__service_1 .selected-location--service-price')
        .text(JSON.services.service_1.price);
      $selectedLocation
        .find('.selected__service_2 .selected-location--service-name')
        .text(JSON.services.service_2.title);
      $selectedLocation
        .find('.selected__service_2 .selected-location--service-price')
        .text(JSON.services.service_2.price);
      $selectedLocation
        .find('.selected__service_3 .selected-location--service-name')
        .text(JSON.services.service_3.title);
      $selectedLocation
        .find('.selected__service_3 .selected-location--service-price')
        .text(JSON.services.service_3.price);
      $selectedLocation
        .find('.selected__service_4 .selected-location--service-name')
        .text(JSON.services.service_4.title);
      $selectedLocation
        .find('.selected__service_4 .selected-location--service-price')
        .text(JSON.services.service_4.price);
      $selectedLocation
        .find('.selected__service_5 .selected-location--service-name')
        .text(JSON.services.service_5.title);
      $selectedLocation
        .find('.selected__service_5 .selected-location--service-price')
        .text(JSON.services.service_5.price);
      //Map
      $selectedLocation
        .find('.selected__map_embed')
        .html(htmlDecode(JSON.map_embed));
      $('.selected__map_embed iframe').on('load', function () {
        $selectedLocation.find('.icon--search-loader').hide();
      });
      $selectedLocation
        .find('.selected__full_map')
        .attr('href', htmlDecode(JSON.map_link));
    }

    function htmlDecode(value) {
      return $('<div/>').html(value).text();
    }

    function renderLocationPage() {
      var $page = $('.locations-page');
      var $selectedLocation = $('.selected-location');
      $selectedLocation.css({
        'pointer-events': 'all',
        opacity: '1',
      });
      $page.height($selectedLocation.outerHeight());
      $('.location-selection').hide();
      window.scrollTo(0, 0);
    }

    function closeLocationPage() {
      var $page = $('.locations-page');
      var $selectedLocation = $('.selected-location');
      $selectedLocation.css({
        'pointer-events': 'none',
        opacity: '0',
      });
      $('.location-selection').show();
      $page.height('auto');
      window.scrollTo(0, 0);
    }

    /* Mobile Handling */
    checkSize();

    var resizeTimeout;
    var clicksBound = false;
    $(window).resize(function () {
      if (!!resizeTimeout) {
        clearTimeout(resizeTimeout);
      }
      resizeTimeout = setTimeout(function () {
        checkSize();
      }, 250); //important for performance, will only fire after 0.5s of no more resizing
    });

    function checkSize() {
      if ($(window).width() < 999) {
        if (!clicksBound) {
          //clickFunctions(); //Don't rebind click function if already set
        }
      } else {
        resetExpandDesktop();
      }
    }

    function clickFunctions() {
      clicksBound = true;
      $northButton.unbind();
      $southButton.unbind();

      $northButton.click(function () {
        expandToggle($northContainer);
      });

      $southButton.click(function () {
        expandToggle($southContainer);
      });
    }

    function expandToggle($container) {
      var $locationContainer = $container.find('.location-container');
      $locationContainer.stop();
      if ($container.hasClass('expanded')) {
        $locationContainer.slideUp();
        $container.removeClass('expanded');
      } else {
        $locationContainer.slideDown({
          start: function () {
            $(this).css('display', '');
            $container.addClass('expanded');
          },
        });
      }
    }

    function resetExpandDesktop() {
      $northButton.unbind(); //unbind click functions
      $southButton.unbind();
      clicksBound = false;
      $northContainer.find('.location-container').stop().slideDown(); //display northContainer
      $southContainer.find('.location-container').stop().slideDown(); //display SouthContainer
    }
  }

  /* Quantity Limiting */
  if ($('.product-form__info-item--quantity').length) {
    var inputQuantitySelector = 'input.form__field--text[name="quantity"]';
    waitForEl(
      inputQuantitySelector,
      function () {
        var limit = $('.product-form__info-item--quantity').data('limit');
        $(inputQuantitySelector).attr('max', limit);
      },
      0
    );
  }
  /*
    //Non-JSON version
    function ProductFormValidate() {
      var $productForm = $('.product-form');
      var $productButton = $productForm.find('.product-form__add-button');
      var limit = $('.product-form__info-item--quantity').data('limit');
      $productButton.click(function(evt){
        validCartQuantity = validateCartQuantity(limit);
        if($productForm.valid() && validCartQuantity) {
          return;
        } else {
          $('.error').get(0).scrollIntoView();
          evt.preventDefault();
          evt.stopPropagation();
        }
      });
    }

    function validateCartQuantity(limit) {
      if(limit == "unset") {return true;}
      var result = true;
      $('.mini-cart__line-item').each(function(){
        var productTitle = $('.product-meta__title').text();
        var cartItemTitle = $(this).find('.mini-cart__product-title').text();
        if (productTitle === cartItemTitle) {
          var cartItemQuantity = $(this).find('.quantity-selector__value').val();
          var productQuantity = $('.product-form__quantity').val();
          var totalQuantity = productQuantity + cartItemQuantity;
          result = (totalQuantity <= limit);
          return false;
        }
      });
      if (result) {
        $('.quantity_limit_disclaimer').removeClass('error');
      } else {
        $('.quantity_limit_disclaimer').addClass('error');
        var calcScroll = $('.error').first().offset().top - $('#shopify-section-header').outerHeight();
        $([document.documentElement, document.body]).animate({
          scrollTop: calcScroll
        }, 500);
      }
      return result;
    }*/

  //JSON version
  function ProductFormValidateJSON() {
    var $productForm = $('.product-form');
    var $productButton = $productForm.find('.product-form__add-button');
    var limit = $('.product-form__info-item--quantity').data('limit');
    var cartItems = null;
    jQuery
      .getJSON('/cart.js', function (cart) {
        cartItems = cart.items;
      })
      .then(function () {
        $productButton.click(function (evt) {
          validCartQuantity = validateCartQuantityJSON(limit, cartItems);
          if ($productForm.valid() && validCartQuantity) {
            return;
          } else {
            evt.preventDefault();
            evt.stopPropagation();
            var calcScroll =
              $('.error').first().offset().top -
              $('#shopify-section-header').outerHeight();
            $([document.documentElement, document.body]).animate(
              {
                scrollTop: 0,
              },
              500
            );
          }
        });
      });

    document.addEventListener('product:added', function (event) {
      jQuery
        .getJSON('/cart.js', function (cart) {
          cartItems = cart.items;
        })
        .then(function () {
          $productButton.unbind();
          $productButton.click(function (evt) {
            validCartQuantity = validateCartQuantityJSON(limit, cartItems);
            if ($productForm.valid() && validCartQuantity) {
              return;
            } else {
              evt.preventDefault();
              evt.stopPropagation();
              var calcScroll =
                $('.error').first().offset().top -
                $('#shopify-section-header').outerHeight();
              $([document.documentElement, document.body]).animate(
                {
                  scrollTop: 0,
                },
                500
              );
            }
          });
          minicartCheckout();
        });
    });
  }

  function validateCartQuantityJSON(limit, cartItems) {
    if (limit == 'unset') {
      return true;
    }
    var result = true;
    $.each(cartItems, function (key, value) {
      var cartProductID = value.product_id;
      var productID = $('.product-meta__title').data('id');
      var cartProductProperties = null;

      if (productID === cartProductID) {
        if (
          $('.line-item-property__field').length &&
          Object.keys(value.properties).length > 0
        ) {
          //need to do additional checking for property match
          var cartProductProperties = value.properties;
          if (
            cartProductProperties['Patient name'] === $('#patient-name').val()
          ) {
            //we don't need to do anything
          } else {
            return true; //this isn't the product we're looking for, skip to next loop.
          }
        }
        var cartItemQuantity = parseInt(value.quantity);
        var productQuantity = parseInt($('.product-form__quantity').val());
        var totalQuantity = productQuantity + cartItemQuantity;
        result = totalQuantity <= limit;
        return false; //We got him, break the loop
      }
    });

    if (result) {
      $('.quantity_limit_disclaimer').removeClass('error');
    } else {
      $('.quantity_limit_disclaimer').addClass('error');
    }
    return result;
  }

  ProductFormValidateJSON();
  minicartCheckout();
  waitForEl(
    '.mini-cart__inner',
    function () {
      minicartCheckout();
    },
    0
  );

  function minicartCheckout() {
    $('.mini-cart__recap button[name="checkout"]').unbind();
    $('.mini-cart__recap button[name="checkout"]').click(function (evt) {
      var result = true;
      $('.quantity-selector').each(function () {
        var $quantitySelector = $(this);
        var $quantitySelectorValue = $(this).find('.quantity-selector__value');
        if (
          parseInt($quantitySelectorValue.attr('max')) <
          parseInt($quantitySelectorValue.val())
        ) {
          $quantitySelector
            .find('.quantity-selector__value')
            .parents('.mini-cart__quantity')
            .siblings('.quantity_limit_disclaimer')
            .removeClass('hidden');
          result = false;
        } else {
          $quantitySelector
            .find('.quantity-selector__value')
            .parents('.mini-cart__quantity')
            .siblings('.quantity_limit_disclaimer')
            .addClass('hidden');
        }
      });
      if (result === false) {
        evt.preventDefault();
        evt.stopPropagation();
      }
    });

    $('.mini-cart__inner .quantity-selector').each(function () {
      var $quantitySelector = $(this);
      var $quantitySelectorValue = $(this).find('.quantity-selector__value');
      if ($quantitySelector.find('.quantity-selector__value').attr('max')) {
        $quantitySelector
          .find('.quantity-selector__button[data-action="increase-quantity"]')
          .unbind();
        $quantitySelector
          .find('.quantity-selector__button[data-action="increase-quantity"]')
          .click(function (evt) {
            validateMiniButtons($quantitySelector, evt);
          }); //set up watcher for increase button click

        if ($quantitySelectorValue.val() > $quantitySelectorValue.attr('max')) {
          console.log('error showing from quantity selector iteration');
          $quantitySelector
            .parents('.mini-cart__quantity')
            .siblings('.error')
            .removeClass('hidden');
        }
      }
    });
  }

  function validateMiniButtons($quantitySelector, evt) {
    console.log('validating mini buttons');
    var $quantitySelectorValue = $quantitySelector.find(
      '.quantity-selector__value'
    );
    if ($quantitySelectorValue.attr('max') <= $quantitySelectorValue.val()) {
      console.log('error showing from validateMiniButtons');
      $quantitySelector
        .parents('.mini-cart__quantity')
        .siblings('.error')
        .removeClass('hidden');
      evt.preventDefault();
      evt.stopPropagation();
    } else {
      console.log('error hiding from validateMiniButtons');
      $quantitySelector
        .parents('.mini-cart__quantity')
        .siblings('.error')
        .addClass('hidden');
    }
  }

  function sameDayDelivery() {
    let $form = $('.modal__same-day-delivery-form');

    if ($form.length) {
      let $input = $form.find('input#postcode-input'),
        $success = $form.find('.result--success'),
        $unavailableError = $form.find('.result__unavailable-error'),
        $validationError = $form.find('.result__validation-error'),
        config = window.sameDayDeliveryConfig,
        successMessageOrig = $success.html();

      $form.on('submit', function (e) {
        e.preventDefault();

        // Hide and reset previous messages
        $success.addClass('hidden').html(successMessageOrig);
        $unavailableError.addClass('hidden');
        $validationError.addClass('hidden');

        let postcodeValue = $input.val(),
          postcodeFound = false,
          postcodeRegion = '',
          orderByTime = config.orderByTime.default;

        // Check if valid postcode
        if (postcodeValue) {
          if (/^\d{4}$/.test(postcodeValue)) {
            config.postcodes.forEach(function (postcode) {
              if (postcodeValue == postcode.id) {
                postcodeFound = true;
                postcodeRegion = postcode.region.toLowerCase();
              }
            });

            // If region has a specific delivery time
            if (postcodeRegion in config.orderByTime) {
              orderByTime = config.orderByTime[postcodeRegion];
            }

            // Delivery available
            if (postcodeFound) {
              let successMessage = successMessageOrig.replace('[time]', orderByTime);
              $success.html(successMessage);
              $success.removeClass('hidden');

              // Delivery not available
            } else {
              $unavailableError.removeClass('hidden');
            }

            // Not a valid postcode
          } else {
            $validationError.removeClass('hidden');
          }
        }
      });

      // Submit form on blur also (to help on mobile)
      $input.on('blur', function (e) {
        $form.trigger('submit');
      });
    }
  }
  sameDayDelivery();

  // Mega Menu
  // $('.nav-bar__linklist').on('mouseenter', () => {
  //   $('.nav-bar__linklist').addClass('set-background');
  //   $('body').addClass('overlay');
  // }).on('mouseleave', () => {
  //   $('.nav-bar__linklist').removeClass('set-background');
  //   $('body').removeClass('overlay');
  // })

  // $('.nav-bar__item').on('mouseenter', (el) => {
  //   $('.nav-bar__item').css('opacity', '0.65');
  //   $(el.currentTarget).css('opacity', '1');
  //   const target = $(el.currentTarget).find('[data-menu-id]').data('menu-id');

  //   $('[data-brand]').removeClass('active');
  //   $('.mega-menu__brand-sub').removeClass('open');

  //   $('[data-top-level]').each((index, submenu) => {
  //     // if($(submenu).data('top-level') === target && topLevel) {
  //     if ($(submenu).data('top-level') === target) {
  //       // $(submenu).removeClass('hidden')
  //       $(submenu).show(1);
  //       // click first of lists
  //       const firstOption = $(submenu).find('.nav-bar__link')[0];
  //       $(firstOption).trigger('click');
  //     }
  //   })

  // }).on('mouseleave', () => {
  //   $('.nav-bar__item').css('opacity', '1');

  //   $('[data-top-level]').fadeOut(1);
  //   $('[data-brand]').removeClass('active');
  //   $('.mega-menu__brand-sub').addClass('hidden');
  //   $('.menu-prom-box').removeClass('show');

  //   $('.mega-menu__inner').attr("aria-hidden", "true");
  //   $('.mega-menu-list').removeClass('is-dropdown-open');
  //   $('.nav-bar__link').attr("aria-expanded", "false");
  // })

  // // sub menu open
  // $('[data-type="mega-menu"]').on('click', (e) => {
  //   e.preventDefault();
  //   const $el = $(e.currentTarget);
  //   $('.mega-menu-list').removeClass('is-dropdown-open');
  //   $('[data-type="mega-menu"]').attr("aria-expanded", "false");
  //   $('[data-type="menu"]').attr("aria-hidden", "true");

  //   $('[data-brand]').removeClass('active');
  //   $('.mega-menu__brand-sub').removeClass('open');
  //   $('.menu-prom-box').removeClass('show');



  //   // promotion 
  //   const tagetProm = $(`.${$(e.currentTarget).data('promotion')}`);
  //   if (tagetProm) {
  //     let $last = $el.next().find('.mega-menu__column.last-item'),
  //       right = $last.offset()?.left + $last.outerWidth(),
  //       left = $(window).width() - tagetProm.outerWidth();

  //     if (right < left) tagetProm.addClass('show');
  //   }

  //   // this > aria-expanded true
  //   $el.attr("aria-expanded", "true");
  //   // mega-menu__inner ( next sibling ) aria-hidden false
  //   $el.next().attr("aria-hidden", "false");
  //   // add open parent
  //   $el.parent().addClass('is-dropdown-open');
  // })

  // $('[data-brand]').on('click', (el) => {
  //   $('[data-brand]').removeClass('active');
  //   $('.mega-menu__brand-sub').removeClass('open');

  //   const target = $(el.currentTarget);
  //   target.addClass('active');
  //   let id = target.data('brand');
  //   if (id) {
  //     $(`.${id}`).addClass('open');
  //   }
  // })

  // screen size & check last `mega-menu__column` right position
  // .menu-prom-box.show left position
  // if left position > right position show other than that remove show


  // // mobile-menu
  // $('[data-type="submenu-item"]').on('click', (el) => {
  //   if ($(el.currentTarget).parent().next('.mobile-menu__subnav').hasClass('open')) {
  //     $(el.currentTarget).parent().next('.mobile-menu__subnav').removeClass('open');
  //   } else {
  //     $('.mobile-menu__subnav').removeClass('open');
  //     $(el.currentTarget).parent().next('.mobile-menu__subnav').addClass('open');
  //   }
  // })
  // // mega menu END

  // /**
  //  * resize window then rerendering promo
  //  */

  // $(window).on('resize', function () {
  //   // check promotion on
  //   const $submenu = $('.is-dropdown-open');
  //   if ($submenu.length > 0) {
  //     $showPromos = $('.menu-prom-box');
  //     // check navigation height
  //     let top = $('.nav-bar').height(),
  //       target = $showPromos[0].classList[1],
  //       tagetProm = $($showPromos[0]);

  //     $showPromos.css('top', `${top}px`);

  //     let $last = $(`[data-promotion="${target}"]`).next().find('.mega-menu__column.last-item'),
  //       right = $last.offset()?.left + $last.outerWidth(),
  //       left = $(window).width() - tagetProm.outerWidth();

  //     if (right < left) tagetProm.addClass('show')
  //     else tagetProm.removeClass('show')
  //   }
  //   // if yes then check navigation height ( sometimes it is 2 lines )
  //   // different top prom-box
  //   // check hide prom box or not.
  // });

});


$('#shopify-section-cart-template').ready(function () {
  /* quantity limiting for cart. Needs massive workaround since theme devs are dumb */
  $('body').on(
    'DOMNodeInserted',
    'section[data-section-id="cart-template"]',
    function () {
      $('.quantity-selector').each(function () {
        var $quantitySelector = $(this);
        var $quantitySelectorValue = $(this).find('.quantity-selector__value');
        if ($quantitySelector.find('.quantity-selector__value').attr('max')) {
          $quantitySelector
            .find('.quantity-selector__button[data-action="increase-quantity]')
            .unbind();
          $quantitySelector
            .find('.quantity-selector__button[data-action="increase-quantity"]')
            .click(function (evt) {
              validateButtons($quantitySelector, evt);
            }); //set up watcher for increase button click
        }
      });

      $('.cart-recap__checkout').unbind(); //unbind previously bound click events
      $('.cart-recap__checkout').click(function (evt) {
        var result = true;
        $('.quantity-selector').each(function () {
          var $quantitySelector = $(this);
          var $quantitySelectorValue = $(this).find(
            '.quantity-selector__value'
          );
          if (
            $quantitySelectorValue.attr('max') < $quantitySelectorValue.val()
          ) {
            $quantitySelector.siblings('.error').removeClass('hidden');
            result = false;
          } else {
            $quantitySelector.siblings('.error').addClass('hidden');
          }
        });

        if (result === false) {
          evt.preventDefault();
          evt.stopPropagation();
        }
      });
    }
  );

  function validateButtons($quantitySelector, evt) {
    var $quantitySelectorValue = $quantitySelector.find(
      '.quantity-selector__value'
    );
    if ($quantitySelectorValue.attr('max') <= $quantitySelectorValue.val()) {
      $quantitySelector.siblings('.error').removeClass('hidden');
      evt.preventDefault();
      evt.stopPropagation();
    } else {
      $quantitySelector.siblings('.error').addClass('hidden');
    }
  }

  function watchProductPageImageBoxHeight() {
    let galleryBox = $('.product-block-list__item--gallery .card');
    let infoBox = $('.product-block-list__item--info .card__section');
    let galleryBoxHeight = galleryBox.outerHeight();
    let infoBoxHeight = infoBox.outerHeight();
    let windowWidth = $(document).width();

    // if(windowWidth > 999){
    //   galleryBox.css("min-height", infoBoxHeight);
    // } else {
    //   galleryBox.css("min-height", 0);
    // }
  }
  watchProductPageImageBoxHeight();
  let resizeObserver = new ResizeObserver(() => {
    watchProductPageImageBoxHeight();
  });
  let infoBox = $('.product-block-list__item--info .card__section')[0];
  if(infoBox) resizeObserver.observe(infoBox);
});

// This is used to sort the store location popup in alphabetical order, and update two of the stores open times
$(document).ready(function() {
    var waitForElement = setInterval(function() {
        if ($('.pickup-store__title').length) {
            clearInterval(waitForElement);

            // Array to store pickup stores with modified titles
            var pickupStores = [];

            // Loop through each .pickup-store element
            $('.pickup-popup .pickup-stores .pickup-store').each(function() {
                var pickupStoreTitle = $(this).find('.pickup-store__title').text();

                // Remove 'Bargain Chemist' from the string
                pickupStoreTitle = pickupStoreTitle.replace('Bargain Chemist', '');

                // Remove leading and trailing whitespaces
                pickupStoreTitle = pickupStoreTitle.replace(/\s/g, '');

                if (pickupStoreTitle == 'Riccarton') {
                  $(this).hide();
                }

                // Push object with title and element to array
                pickupStores.push({
                    title: pickupStoreTitle,
                    element: $(this)
                });
            });

            // Sort pickupStores array by title in alphabetical order
            pickupStores.sort(function(a, b) {
                return a.title.localeCompare(b.title);
            });

            // Empty the container and append sorted elements
            $('.pickup-popup .pickup-stores').empty();
            $.each(pickupStores, function(index, store) {
                $('.pickup-popup .pickup-stores').append(store.element);
            });
        }
    }, 100); // Check every 100 milliseconds
});


function lookForMatchingGiftCard(z) {
  const giftCardSelect = $('.product-form__single-selector');
  $(".product-form__single-selector > option").each(function() {
    const optionText = $(this).text;
    const s = this.text;
    const removeDecimals = s.substring(0, s.indexOf('.')).replace('$', '');
    if(removeDecimals == z) {
      const matchedOption = $(this).val();
      giftCardSelect.val(matchedOption);
      giftCardSelect.change();
      const selectChangeEvent = new Event('change', {bubbles: true});
      giftCardSelect[0].dispatchEvent(selectChangeEvent);
    }
  });
}

function roundFive(){
 a = document.forms["myForm"].inp.value
 z = Math.round(parseFloat(a)/10)*10;
}

$( "#inputtedValue" ).on( "blur", function() {
  if(z < 10) {
    $(this).val(10);
    z = '10';
  } else {
    $(this).val(z);
  }

  if(z > 1000) {
    $(this).val(1000);
    z = '1,000';
  }
  
  lookForMatchingGiftCard(z);
} );

document.addEventListener('DOMContentLoaded', function() {
  $('.pickup-popup__title').text('Our Locations');
  $('.pickup-popup__content.rte').hide();

  $('.pickup-store').click(function(e){ 
      e.preventDefault();     
      return false;
  });
});

function waitForElement(selector, callback) {
  const element = document.querySelector(selector);
  if (element) {
    callback();
  } else {
    setTimeout(() => {
      waitForElement(selector, callback);
    }, 100); // Check again after 100 milliseconds
  }
}

waitForElement('.con-like', function() {
  $('.con-like').on('click', function() {
    console.log('clicked heart');
    var iwishAnchor = $(this).parent().find('.iWishAddColl');
    $(this).parent().find('.iWishAddColl').trigger('click');
    console.log('iwishAnchor', iwishAnchor);
  });
});


// Function to check and update checkbox state based on iWishAdd content
function updateCheckboxState() {
  const iWishAddElement = $('.product-page__iwishwrap .iWishAdd');
  
  const iWishText = iWishAddElement.text().trim();
  if (iWishText.includes('Added in Shopping List')) {
    console.log('Added in Shopping List is there');
    // If 'Added in Shopping List' is present, check the like checkbox
    const likeCheckbox = iWishAddElement.siblings('.con-like').find('.like');
    if (likeCheckbox.length > 0) {
      likeCheckbox.prop('checked', true);
      likeCheckbox.siblings('.checkmark').find('.filled').show();
      likeCheckbox.siblings('.checkmark').find('.celebrate').show();
    }
  } else {
    console.log('Added in Shopping List is not there');
    // If 'Added in Shopping List' is not present, uncheck the like checkbox
    const likeCheckbox = iWishAddElement.siblings('.con-like').find('.like');
    if (likeCheckbox.length > 0) {
      likeCheckbox.prop('checked', false);
      likeCheckbox.siblings('.checkmark').find('.filled').hide();
      likeCheckbox.siblings('.checkmark').find('.celebrate').hide();
    }
  }
}

// Call the function to check initial state
$(document).ready(function() {
  updateCheckboxState();

  // Create a MutationObserver to watch for changes in the .iWishAdd element
  const observer = new MutationObserver(function(mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // If the content changes, update the checkbox state
        updateCheckboxState();
      }
    }
  });

  // Start observing changes in the .iWishAdd element
  const iWishAddElement = document.querySelector('.product-page__iwishwrap .iWishAdd');
  // observer.observe(iWishAddElement, { childList: true, subtree: true });
  
  // Event handler for clicking the con-like element
  $('.product-page__iwishwrap .con-like').on('click', function() {
    console.log('clicked heart');
    $(this).parent().find('.iWishAdd').trigger('click');
  });
});

// Check if a limit exists on a product, if so make sure the plus button is disabled if it will exeed the limit

$('body').on('click', '.mini-cart__quantity .quantity-selector__button', function() {
  // Get the line item parent from the quantity selector clicked
  var lineItemQuantClicked = $(this).closest('.mini-cart__line-item');

  // Find the product limit from the liquid value in mini-cart.liquid file
  var limitOnProdQuantityElement = lineItemQuantClicked.find('.js-lineitem-quantity-limit');

  // Get the red disclaimer message for the line item
  var disclaimerMessage = lineItemQuantClicked.find('.quantity_limit_disclaimer');

  // Get the current value of the quantity input
  var quantityInput = lineItemQuantClicked.find('.quantity-selector__value');
  var currentLineItemQuantity = parseInt(quantityInput.val());

  // If a limit exists
  if (limitOnProdQuantityElement.length > 0) {
    var limitOnProdQuantityNumber = parseInt(limitOnProdQuantityElement.text());

    if (currentLineItemQuantity >= limitOnProdQuantityNumber) {
      // Disable the plus button
      lineItemQuantClicked.find('.quantity-selector__button[data-action="increase-quantity"]').prop('disabled', true);
      disclaimerMessage.removeClass('hidden');
    } else {
      // Enable the plus button
      lineItemQuantClicked.find('.quantity-selector__button[data-action="increase-quantity"]').prop('disabled', false);
      disclaimerMessage.addClass('hidden');
    }
  }
});

$('body').on('input', '.mini-cart__quantity .quantity-selector__value', function() {
   console.log('input is being inputted');

  // Get the line item parent from the quantity selector clicked
  var lineItemQuantClicked = $(this).closest('.mini-cart__line-item');

  // Find the product limit from the liquid value in mini-cart.liquid file
  var limitOnProdQuantityElement = lineItemQuantClicked.find('.js-lineitem-quantity-limit');

  // Get the red disclaimer message for the line item
  var disclaimerMessage = lineItemQuantClicked.find('.quantity_limit_disclaimer');

  // Get the current value of the quantity input
  var quantityInput = $(this);
  var currentLineItemQuantity = parseInt(quantityInput.val());

  // Add an event listener to the input field
  var newQuantity = parseInt($(this).val());
  console.log('input is being inputted', newQuantity);

  var limitOnProdQuantityNumber = parseInt(limitOnProdQuantityElement.text());

  if (newQuantity >= limitOnProdQuantityNumber) {
    // If the new input value is greater than or equal to the limit, restrict it to the limit
    $(this).val(limitOnProdQuantityNumber);
    disclaimerMessage.removeClass('hidden');
  } else {
    disclaimerMessage.addClass('hidden');
  }
});

$('body').on('input', '.line-item__quantity .quantity-selector__value', function() {
   console.log('cart template input is being inputted');

  // Get the line item parent from the quantity selector clicked
  var lineItemQuantClicked = $(this).closest('.line-item');

  // Find the product limit from the liquid value in mini-cart.liquid file
  var limitOnProdQuantityElement = lineItemQuantClicked.find('.js-lineitem-quantity-limit');

  // Get the red disclaimer message for the line item
  var disclaimerMessage = lineItemQuantClicked.find('.quantity_limit_disclaimer');

  // Get the current value of the quantity input
  var quantityInput = $(this);
  var currentLineItemQuantity = parseInt(quantityInput.val());

  // Add an event listener to the input field
  var newQuantity = parseInt($(this).val());
  console.log('input is being inputted', newQuantity);

  var limitOnProdQuantityNumber = parseInt(limitOnProdQuantityElement.text());

  console.log('limitOnProdQuantityNumber', limitOnProdQuantityNumber);

  if (newQuantity >= limitOnProdQuantityNumber) {
    // If the new input value is greater than or equal to the limit, restrict it to the limit
    $(this).val(limitOnProdQuantityNumber);
    disclaimerMessage.removeClass('hidden');
  } else {
    disclaimerMessage.addClass('hidden');
  }
});


// Trigger popup from 'click & collect only' button on the product page

$('.in-store-label-button').on('click', function() {
  $('.pickup-store-collect button').trigger('click');
});

$('button[data-target="pickup"], .toggle-product-popup').on('click', function() {
  $('.modal--pickup-popup').addClass('show_modal')
});

$('.pickup-popup__close').on('click', function() {
  $('.modal--pickup-popup').removeClass('show_modal')
});



// Generic locations popup

async function processLocationsData() {
    const locationData = await fetchLocationsData();
    const locationsPopupDiv = document.querySelector('.js-locations-generic .pickup-stores');
    if (locationsPopupDiv) {
        for(const item in locationData) {
            const location = locationData[item];
            // Hide specific stores before creating DOM
            if (
                location.name.includes('Birkenhead') ||
                location.name.includes('Archers Road') ||
                location.name.includes('Default fulfillment')
            ) {
                continue;
            }
            const locationLinkPart = location.name.replace(/\s+/g, '-');
            // Append a row inside the .locations-popup div
            const locationRow = document.createElement('div');
            var openingHours = '8:00am - 6:00pm';
            if(location.name == 'Archers Road' || location.name == 'George Street' || location.name == 'Westgate' || location.name == 'Whangaparaoa' || location.name == 'Hornby' || location.name == 'Manukau' || location.name == 'Northwood' || location.name == 'Pakuranga' || location.name == 'Papanui' || location.name == 'Porirua' || location.name == 'Shirley' || location.name == 'Tower Junction') {
              var openingHours = '8:00am - 8:00pm';
            }
            locationRow.className = 'pickup-store';
            // Add content or customize the row as needed
            locationRow.innerHTML = `<div class="pickup-store__title"><span><svg viewBox="0 0 18 26" fill="none" xmlns:v="https://vecta.io/nano" class="icon icon--map-marker"><path d="M9.234 26.791h0a1.027 1.027 0 0 1-.912-.513C7.467 25.081 0 13.965 0 9.234a9.234 9.234 0 0 1 18.468 0c0 4.674-7.467 15.789-8.322 17.043a1.027 1.027 0 0 1-.912.514zm0-24.568a7.006 7.006 0 0 0-7.011 7.011c0 3.021 4.446 10.488 7.011 14.421 2.565-3.933 7.011-11.4 7.011-14.421a7.006 7.006 0 0 0-7.011-7.011zm.005 8.489a2.02 2.02 0 0 1-2-2v-.1a2 2 0 1 1 3.99 0v.114a1.95 1.95 0 0 1-1.99 1.986z"></path></svg></span>
                        Bargain Chemist
                        ${location.name}
                    </div>
                    <div class="pickup-store__address"><div class="store-details"><p>
                                ${openingHours}
                      <a href="/pages/bargain-chemist-${locationLinkPart}" target="_blank">View Details</a>
                    </div> 
                    </div>`;
          
            locationsPopupDiv.appendChild(locationRow);
        }
    }
}

processLocationsData();

function fetchLocationsData() {
    const URL = `https://www.bargainchemist.co.nz/apps/portal/locations`;
    return fetch(URL, {
        headers: {
            'Accept': 'application/json',
        },
    })
    .then(response => response.json())
    .catch(error => console.log('Error while fetching:', error))
}

// Function to update text based on data-value attribute
function updateText() {
    var elements = document.querySelectorAll('.klevuFilterOption');
    elements.forEach(function(element) {
        var value = element.getAttribute('data-value');
        var textNode = element.querySelector('.kufacet-text');
        if (value === 'true') {
            textNode.textContent = 'Click & Collect';
        } else if (value === 'false') {
            textNode.textContent = 'Delivery';
        }
    });
}

// Function to constantly update text
function constantUpdate() {
    setInterval(function() {
        updateText();
    }, 500); // Update every 500 milliseconds
}

// Wait for the element to be available and then start constant updates
waitForElement('.kuFilterNames', function() {
    constantUpdate();
    updateText(); // Update text initially
});


function addToCartAjax(e,vid){
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: vid
    },
    dataType: 'json', 
    success: function (data) { 
      console.log(data);
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          quantity: 1
        }
      }));
    } 
  });
}



// Both search & collection page
$('.kuResults .klevuProduct').each(() => {
  const productID = 43032414421129;

  fetch(`https://www.bargainchemist.co.nz/apps/portal/inventory?productIds=${productID}`).then(response => {
    return response.json();
  })
  .then((response) => {
    console.log('response!!!', response);


  })
  .catch((error) => {
    console.error('Error:', error);
  });
})
